"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsMetaService", {
    enumerable: true,
    get: function() {
        return JobsMetaService;
    }
});
const _common = require("@nestjs/common");
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _Jobs = require("~/interface/Jobs");
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let JobsMetaService = class JobsMetaService {
    async list(context, param, req) {
        /*
     * List jobs for the current base.
     * If the job is not created by the current user, exclude the result.
     * List jobs updated in the last 1 hour or jobs that are still active(, waiting, or delayed).
     */ return _models.Job.list(context, {
            xcCondition: {
                _and: [
                    ...param.job ? [
                        {
                            job: {
                                eq: param.job
                            }
                        }
                    ] : [],
                    ...param.status ? [
                        {
                            status: {
                                eq: param.status
                            }
                        }
                    ] : [],
                    {
                        _or: [
                            {
                                updated_at: {
                                    gt: _Noco.default.ncMeta.formatDateTime((0, _dayjs.default)().subtract(1, 'hour').toISOString())
                                }
                            },
                            {
                                status: {
                                    eq: _Jobs.JobStatus.ACTIVE
                                }
                            },
                            {
                                status: {
                                    eq: _Jobs.JobStatus.WAITING
                                }
                            },
                            {
                                status: {
                                    eq: _Jobs.JobStatus.DELAYED
                                }
                            }
                        ]
                    }
                ]
            }
        }).then((jobs)=>{
            return jobs.map((job)=>{
                if (job.fk_user_id === req.user.id) {
                    return job;
                } else {
                    const { result } = job, rest = _object_without_properties_loose(job, [
                        "result"
                    ]);
                    return rest;
                }
            });
        });
    }
    constructor(){}
};
JobsMetaService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [])
], JobsMetaService);
